import type { FetchFunction } from '#layers/base/utils/api-fetch';
import { createApiFetch } from '#layers/base/utils/api-fetch';
import { useWorkspaceApiBaseUrl } from '#layers/base/utils/workspace-api-base-url';

const apiFetch = createApiFetch();

// Resolved per call: the base URL depends on the selected workspace.
const workspaceFetch: FetchFunction = (endpoint, options) => apiFetch(endpoint, {
	baseURL: useWorkspaceApiBaseUrl(),
	...options,
}) as Promise<any>;

export function useWorkspaceFetch() {
	return workspaceFetch;
}
